import React from "react";

import PageName from "../../shared/components/PageName";

import cameraVideo from "../../../shared/assets/videos/cameraVideo.mp4";

import classes from "./CamerasPage.module.css";

const CamerasPage = () => {
  return (
    <div>
      <PageName pageName="Cameras" />
      <div className={classes["cameras-wrapper"]}>
        <div className={classes["video"]}>
          <video
            autoPlay
            className={classes["camera"]}
            src={cameraVideo}
          ></video>
          <p>9 sinf</p>
        </div>
        <div className={classes["video"]}>
          <video
            autoPlay
            className={classes["camera"]}
            src={cameraVideo}
          ></video>
          <p>9 sinf</p>
        </div>
        <div className={classes["video"]}>
          <video
            autoPlay
            className={classes["camera"]}
            src={cameraVideo}
          ></video>
          <p>9 sinf</p>
        </div>
        <div className={classes["video"]}>
          <video
            autoPlay
            className={classes["camera"]}
            src={cameraVideo}
          ></video>
          <p>9 sinf</p>
        </div>
        <div className={classes["video"]}>
          <video
            autoPlay
            className={classes["camera"]}
            src={cameraVideo}
          ></video>
          <p>9 sinf</p>
        </div>
        <div className={classes["video"]}>
          <video
            autoPlay
            className={classes["camera"]}
            src={cameraVideo}
          ></video>
          <p>9 sinf</p>
        </div>
        <div className={classes["video"]}>
          <video
            autoPlay
            className={classes["camera"]}
            src={cameraVideo}
          ></video>
          <p>9 sinf</p>
        </div>
        <div className={classes["video"]}>
          <video
            autoPlay
            className={classes["camera"]}
            src={cameraVideo}
          ></video>
          <p>9 sinf </p>
        </div>
        <div className={classes["video"]}>
          <video
            autoPlay
            className={classes["camera"]}
            src={cameraVideo}
          ></video>
          <p>9 sinf</p>
        </div>
      </div>
    </div>
  );
};

export default CamerasPage;
